import client from '../client';

/**
 *
 * @param uuid
 * @param customer
 */
const identify = (uuid, customer) => {
  client.identify(uuid, customer);
};

export default identify;
